<div class="cart-vehicle-empty mwb-4">
  <div class="fls-0-0 ai-ctr fld-row flg-5">
    <div class="fls-3-1 fld-col">
      <strong class="fls-1-1 mwy-2">No Vehicle Added</strong>
      <span class="fls-1-1 mwy-2">Please add a vehicle to get started</span>
    </div>
  </div>
</div>
